(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifTableSort', tableSort);


    /**
    * @ngdoc directive
    * @name swif.ui:tableSort
    * @module swif.ui
    * @description The job of table sort is to update the filter to change the sortOn
    * @restrict A
    **/
    function tableSort() {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                swifTableSort: '@'
            },
            replace:true,
            transclude: true,
            link: function (scope, element, attr, ngModel) {
                element.addClass('sortable');
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    scope.hasFilterModel = (vv !== undefined);
                    if (scope.hasFilterModel) {
                        var splited = vv.split(' ');
                        if (scope.predicate !== splited[0]) {
                            scope.predicate = splited[0];
                        }
                        var reverse = splited[1] === 'DESC' ? true : false;
                        if (scope.reverse !== reverse) {
                            scope.reverse = reverse;
                        }
                    }
                };
                var onclick = function () {
                    if (scope.predicate === scope.swifTableSort) {
                        scope.reverse = !scope.reverse;
                        scope.$apply('reverse');
                    } else {
                        scope.predicate = scope.swifTableSort;
                        scope.reverse = false;
                        scope.$apply('predicate');
                    }
                };
                element.bind('click', onclick);
                scope.$on('$destroy', function () {
                    element.unbind('click', onclick);
                });
                scope.$watchGroup(['predicate','reverse'], function (newV, oldV) {
                    if (oldV[0] === undefined && oldV[1] === undefined) {
                        return;
                    }
                    if (newV[0] !== scope.swifTableSort) {
                        return;
                    }
                    if (!_.isEqual(newV, oldV)) {
                        if (newV[0] === undefined) {
                            ngModel.$setViewValue();
                        } else {
                            var sortStr = newV[0] + ' ';
                            sortStr += newV[1] ? 'DESC' : 'ASC';
                            var vv = ngModel.$viewValue;
                            if (vv !== sortStr) {
                                ngModel.$setViewValue(sortStr);
                            }
                        }
                    }
                });
            },
            templateUrl: 'partials/ui/tableSort.html'
        };
    }

})();
